module.exports = {"511083001":"古湖街道","511083002":"金鹅街道","511083101":"山川镇","511083102":"响石镇","511083103":"圣灯镇","511083104":"黄家镇","511083105":"双凤镇","511083106":"龙市镇","511083107":"迎祥镇","511083108":"界市镇","511083109":"石碾镇","511083110":"周兴镇","511083111":"渔箭镇","511083112":"石燕桥镇","511083113":"李市镇","511083114":"胡家镇","511083115":"云顶镇","511083116":"桂花井镇","511083117":"普润镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511083.json
// module id = 2328
// module chunks = 0